   
                        
  
                                                                      
                                    
   

import Ivia from "./ivia";
import { inBrowser } from "./util/environment";

if (inBrowser) {
  let $ = window.jQuery || window.Zepto || window.$ || null;

  if ($) {
    Ivia.$ = $;
  }
}

export default Ivia;



// WEBPACK FOOTER //
// ./src/index.js